import React from 'react'
import { FieldHookConfig, useField } from 'formik'

type CheckboxInputProps = FieldHookConfig<boolean> & {
  label?: string
  wrapperClassName?: string
  className?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onValueChange?: (value: boolean) => void // Yeni prop
  disabled?: boolean
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  label,
  wrapperClassName = '',
  className = '',
  onValueChange,
  disabled = false,
  ...props
}) => {
  const [field, meta, helpers] = useField({...props, type: 'checkbox'})
  const isInvalid = meta.touched && meta.error

  return (
    <div className={wrapperClassName}>
      <div className='custom-checkbox-wrapper'>
        <input
          type='checkbox'
          id={field.name}
          name={field.name}
          checked={field.value || false}
          disabled={disabled}
          onChange={(e) => {
            const newValue = e.target.checked
            helpers.setValue(newValue)
            
            // onChange callback'i varsa çağır
            if (props.onChange) {
              props.onChange(e)
            }
            
            // onValueChange callback'i varsa çağır
            if (onValueChange) {
              onValueChange(newValue)
            }
          }}
          onBlur={field.onBlur}
          className={`custom-checkbox-input ${className} ${isInvalid ? 'is-invalid' : ''}`}
        />
        {label && (
          <label htmlFor={field.name} className='custom-checkbox-label'>
            {label}
          </label>
        )}
        {isInvalid && <div className='invalid-feedback'>{meta.error}</div>}
      </div>
    </div>
  )
}

export default CheckboxInput